module.exports = __webpack_public_path__ + "img/achievement3.5ece9794.jpeg";